import React, { useRef } from 'react';
import { useTransform, useReducedMotion } from 'framer-motion';
import { motion } from '../lib/motionShim';
import { useViewportProgress } from '../lib/useViewportProgress';

/** Oversized outlined numeral that drifts against scroll and fades at the edges. */
const GhostNumeral = ({
  children,
  className = '',
  stroke = 'rgba(168,85,247,0.16)',
  size = 'clamp(120px, 13vw, 200px)',
}) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const scrollYProgress = useViewportProgress(ref);
  const y = useTransform(scrollYProgress, [0, 1], [46, -46]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.75, 1], [0, 1, 1, 0]);

  return (
    <motion.span
      ref={ref}
      aria-hidden="true"
      className={`font-outfit font-black italic select-none pointer-events-none leading-none ${className}`}
      style={{
        fontSize: size,
        color: 'transparent',
        WebkitTextStroke: `2px ${stroke}`,
        y: reduce ? 0 : y,
        opacity: reduce ? 1 : opacity,
      }}
    >
      {children}
    </motion.span>
  );
};

export default GhostNumeral;
